import type { SuggestedActivity } from '@domain/models/suggested-activities'

function asOptionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim().length > 0 ? value : undefined
}

export class SuggestedActivityConverter {
  public static fromFirestore(
    uid: string,
    data: Record<string, unknown>,
  ): SuggestedActivity {
    return {
      uid,
      title: typeof data.title === 'string' ? data.title : '',
      description: typeof data.description === 'string' ? data.description : '',
      length: asOptionalString(data.length),
      imageUrl: typeof data.image_url === 'string' ? data.image_url : '',
      externalLinkUrl: asOptionalString(data.external_link_url),
      categoryId: typeof data.category_id === 'string' ? data.category_id : '',
    }
  }

  public static toFirestore(
    activity: Omit<SuggestedActivity, 'uid'>,
  ): Record<string, unknown> {
    return {
      title: activity.title,
      description: activity.description,
      length: activity.length ?? null,
      image_url: activity.imageUrl,
      external_link_url: activity.externalLinkUrl ?? null,
      category_id: activity.categoryId,
    }
  }
}
